import axios from 'axios';

const administrationModule = process.env.VUE_APP_MODULE_ADMINISTRATION;
// const lookupPrefix = `${administrationModule}/lookups`;
const lookupPrefix = `api/lookups`;

export default {
  getCountries: () => axios.get(`${lookupPrefix}/countries`),
  getCities: () => axios.get(`${lookupPrefix}/cities`, getQueryParamsWithFilters([{
    field: 'isActive',
    value: 1,
  }])),
  getCitiesByRegion: regionId =>
    axios.get(`${lookupPrefix}/cities`, getQueryParamWithOneFilter('regionId', regionId)),
  getDistrictsByCity: cityId =>
    axios.get(`${lookupPrefix}/districts`, getQueryParamWithOneFilter('cityId', cityId)),
  getRegions: () => axios.get(`${lookupPrefix}/regions`, getQueryParamsWithFilters([{
    field: 'isActive',
    value: 1,
  }])),
  getCentersByCity: cityId =>
    axios.get(`${lookupPrefix}/centers`, getQueryParamWithOneFilter('cityId', cityId)),
  getPublicAndPersonalStatusCourts: () => axios.get(`${lookupPrefix}/case-classification-courts`, getQueryParamWithOneFilter('caseClassificationIds', '1,5')),
  getCaseTypesByCategory: caseCategoryId => axios.get(`${lookupPrefix}/case-category-portal-case-types`, getQueryParamWithOneFilter('caseCategoryId', caseCategoryId)),
  getUserCaseClassifications: () => axios.get(`${lookupPrefix}/user/case-classifications`),
  getUserCaseCategories: caseClassificationId => axios.get(`${lookupPrefix}/user/case-classifications/${caseClassificationId}/case-categories`, getQueryParamWithOneFilter('caseClassificationId', caseClassificationId)),
  getCriminalCaseTypes: () => axios.get(`${administrationModule}/cases-types/criminal-case-types`),
  getUserCaseTypes: caseCategoryId => axios.get(`${lookupPrefix}/user/case-categories/${caseCategoryId}/case-types`, getQueryParamWithOneFilter('caseCategoryId', caseCategoryId)),
  getSubLanguages: mainLanguageId => axios.get(`${lookupPrefix}/languages/sub-languages/${mainLanguageId}`),
  getMainSubLanguageDetailsById: id => axios.get(`${lookupPrefix}/languages/main-sub-language-details/${id}`),
  getMinorCases: () => axios.get(`${lookupPrefix}/minor-cases`),
  getRelatives: () => axios.get(`${lookupPrefix}/relatives`),
  getInstrumentSources: () => axios.get(`${lookupPrefix}/termination-dispute-courts`),
  getAttachmentCategories: () => axios.get(`${lookupPrefix}/attachment-types`),
  getWorkPlaces: () => axios.get(`${lookupPrefix}/work-places`),
  getReconciliationLocations: () => axios.get(`${lookupPrefix}/reconciliation-locations`),
  getGovernmentAgencies: () =>
    axios.get(`${lookupPrefix}/organizations`, getQueryParamsWithFilters([
      {
        field: 'organizationTypeId',
        value: 4,
      },
      {
        field: 'isActive',
        value: true,
      },
    ])),
  getEmbassies: () =>
    axios.get(`${lookupPrefix}/organizations`, getQueryParamWithOneFilter('organizationTypeId', 5)),
  getAssociations: () =>
    axios.get(`${lookupPrefix}/organizations`, getQueryParamWithOneFilter('organizationTypeId', 6)),
  getPrisons: () => axios.get(`${lookupPrefix}/prisons`),
  getPrisonerStatuses: () => axios.get(`${lookupPrefix}/prisoner-status`),
  getSocialTypes: () => axios.get(`${lookupPrefix}/portal-identity-types`),
  getSocialTypesWithCommercialReg: () => axios.get(`${lookupPrefix}/identity-with-commercial`),
  getPartyTypes: () =>
    axios.get(`${lookupPrefix}/party-types`, getQueryParamWithOneFilter('statusId', 1)),
  getCessationTypes: () => axios.get(`${lookupPrefix}/cessation-types`),
  getPartyReferences: () => axios.get(`${lookupPrefix}/party-references`),
  getCourtSubCircles: courtUUID =>
    axios.get(`${administrationModule}/courts/${courtUUID}/subCircles`),
  getAllCourtSubCircles: courtID =>
    axios.get(`${administrationModule}/courts/${courtID}/all-subCircles`),
  getRejectionReasons: category =>
    axios.get(
      `${lookupPrefix}/rejection-reasons`,
      getQueryParamWithOneFilter('category', category)
    ),
  getCitiesByCourtType: courtTypeId =>
    axios.get(`${lookupPrefix}/cities-by-court-type`, getQueryParamsWithFilters([{
      field: 'CourtTypeId',
      value: courtTypeId,
    }])),
  getGeneralCityCourtByType: cityId =>
    axios.get(`${lookupPrefix}/city-court-by-type`, getQueryParamsWithFilters([{
      field: 'cityId',
      value: cityId,
    },
    {
      field: 'courtTypeId',
      value: 5,
    }, {
      field: 'canBeSentToAppealWithoutFI',
      value: false,
    },
    ])),
  getPersonalCityCourtByType: cityId =>
    axios.get(`${lookupPrefix}/city-court-by-type`, getQueryParamsWithFilters([{
      field: 'cityId',
      value: cityId,
    },
    {
      field: 'courtTypeId',
      value: 1,
    },
    {
      field: 'canBeSentToAppealWithoutFI',
      value: false,
    },
    ])),
  getCriminalCityCourtByType: cityId =>
    axios.get(`${lookupPrefix}/city-court-by-type`, getQueryParamsWithFilters([{
      field: 'cityId',
      value: cityId,
    },
    {
      field: 'courtTypeId',
      value: 4,
    },
    {
      field: 'canBeSentToAppealWithoutFI',
      value: false,
    },
    ])),
  getLawsuitEmployees: () =>
    axios.get(`${lookupPrefix}/courts/@current/lawsuit-department-employees`),
  getServicesCenterEmployees: employeeType =>
    axios.get(`${lookupPrefix}/services-center-employees`, { params: { servicesCenterEmployeeType: employeeType } }),
  getCentralAuditEmployees: () => axios.get(`${lookupPrefix}/central-audit-department-employees`),
  getAuditPaths: () => axios.get(`${lookupPrefix}/audit-paths`),
  getGovernmentalOrganizations: () => axios.get(`${lookupPrefix}/governmental-organizations`),
  getAllCaseTypes: () => axios.get(`${lookupPrefix}/cases-types`),
  getPortalPartyRoles: () => axios.get(`${lookupPrefix}/portal-party-roles`),
  getPortalRequestStatus: () => axios.get(`${lookupPrefix}/portal-request-status`),
  getDecisionTypes: () => axios.get(`${lookupPrefix}/decision-types`),
  getLanguages: () => axios.get(`${lookupPrefix}/languages`, getQueryParamsWithFilters([{
    field: 'statusId',
    value: 1,
  }])),
  getAllCourts: () => axios.get(`${lookupPrefix}/all-courts`),
  getMergedActiveCourts: () => axios.get(`${lookupPrefix}/merged-active-courts`),
  getContractTypes: () => axios.get(`${lookupPrefix}/contract-types`),
  getSalaryPaymentIntervals: () => axios.get(`${lookupPrefix}/salary-payment-intervals`),
  getContractDropReasons: () => axios.get(`${lookupPrefix}/contract-drop-reasons`),
  getLaborRequests: () =>
    axios.get(`${lookupPrefix}/labor-requests`, getQueryParamWithOneFilter('isActive', 1)),
  getLaborRequestsForm: subLaborRequestType =>
    axios.get(`${administrationModule}/forms/labor-requests/${subLaborRequestType}`),
  getLaborEvidences: () => axios.get(`${lookupPrefix}/evidences`),
  getLaborEvidencesForm: evidenceType =>
    axios.get(`${administrationModule}/forms/evidences/${evidenceType}`),
  getCourtReplyTypes: () => axios.get(`${lookupPrefix}/supreme-appeal-court-reply-types`),
  getMainLanguages: () => axios.get(`${lookupPrefix}/main-languages`, getQueryParamsWithFilters([{
    field: 'IsActive',
    value: 1,
  }])),
  getCourts: payload => axios.get(`${lookupPrefix}/active-courts`, payload),
  getDiplomaticAuthorities: () =>
    axios.get(`${lookupPrefix}/diplomatic-authorities`),
  getSubAuthoritiesByCentralAuthorityId: centralAuthorityId =>
    axios.get(`${lookupPrefix}/sub-authorities`, getQueryParamsWithFilters([{
      field: 'centralAuthorityId',
      value: centralAuthorityId,
    }])),
  getCentralAuthoritiesForMinistries: organizationId =>
    axios.get(`${lookupPrefix}/central-authorities-ministries`, getQueryParamsWithFilters([{
      field: 'organizationId',
      value: organizationId,
    }])),
  getLaborCities: () =>
    axios.get(`${lookupPrefix}/labor-cities`),
  getCourtByLaborCity: cityId =>
    axios.get(`${lookupPrefix}/labor-city-court`, getQueryParamsWithFilters([{
      field: 'cityId',
      value: cityId,
    }])),
  getCaseRequestTypes: () => axios.get(`${lookupPrefix}/portal-request-types`),
  getPartyRoles: () => axios.get(`${lookupPrefix}/portal-request-types`),
  getActiveCourts: () => axios.get(`${lookupPrefix}/active-courts`),
  getSocialTypesForAnonymousUser: () => axios.get(`${lookupPrefix}/social-types`),
  getCaseTypeTree: () => axios.get(`${lookupPrefix}/case-type-tree`),
  getPartyAttributesPartyRoles: () => axios.get(`${lookupPrefix}/party-attributes-party-roles`), // دور الطرف
  getIncomingRequestsTypes: () => axios.get(`${lookupPrefix}/incoming-request-types`),
  getRequestStatus: () => axios.get(`${lookupPrefix}/request-status`),
  getCassationRequestReasons: () => axios.get(`${lookupPrefix}/cassation-request-reasons`),
};

const getQueryParamWithOneFilter = (field, value) => ({
  params: {
    query: {
      filters: [{
        field,
        value,
      }],
    },
  },
});

const getQueryParamsWithFilters = filters => ({ params: { query: { filters: filters } } });